export default __webpack_public_path__ + "static/media/14 ProfessionalDetails – 1@2x.cb2c536f.png";